/**
 * modules
 */

import preloader from '../../../templates/_atoms/preloader/_script';
import codeSnippet from '../../../templates/_atoms/codeSnippet/_script';
import imageSlider from '../../../templates/_organisms/imageSlider/_script';
import imageGallery from '../../../templates/_organisms/imageGallery/_script';
import appHeader from '../../../templates/_organisms/appHeader/_script';
import accordion    from '../../../templates/_organisms/accordion/_script';
import contactForm from '../../../templates/_organisms/contactForm/_script';
import map from '../../../templates/_organisms/map/_script';
// import cookiebar    from '../../../templates/_modules/cookiebar/_main'
// import imageSlider  from '../../../templates/_modules/imageSlider/_main'
// import imageGallery from '../../../templates/_modules/imageGallery/_main'
// import navCategories from '../../../templates/_modules/navCategories/_main'

// Modules Array
const modulesArray = [
    preloader,
    codeSnippet,
    imageSlider,
    imageGallery,
    appHeader,
    accordion,
    contactForm,
    map,
    // cookiebar,
    // imageGallery,
    // navCategories
];

const modules = {
    // Modules
    Modules() {
        if (modulesArray.length > 0 && modulesArray !== undefined) {
            modulesArray.forEach((module) => {
                module.init();
            });
        }
    },

    init() {
        this.Modules();
    }
};

export default modules;



// WEBPACK FOOTER //
// ./___src/assets/js/partials/modules.js